import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';

const _httpService = new HttpService();

const getPreviousBaseURL = () => {
  return checkIsInternal()
    ? config('API_DOMAIN_INTERNAL')
    : config('API_DOMAIN_EXTERNAL');
};

/**
 * Fetch TIN group details by group name and user ID
 * Similar to Angular's openEditTinsModal logic
 * @param groupName - The group name to search for (defaults to 'unsaved' if not provided)
 * @param userId - The user's MS ID
 * @returns Promise with JobId if successful, null otherwise
 */
export const fetchTinGroupDetails = async (groupName: string, userId: string): Promise<{ JobId: string } | null> => {
  const previousBaseURL = getPreviousBaseURL();
  _httpService.setBaseURL(config('BULK_PROCESSING_API') || '');

  const url = '/saved-tins-bulk-process/search-group-details';
  const payload = {
    GroupName: groupName || 'unsaved',
    UserId: userId
  };

  try {
    const response: any = await _httpService.push(url, payload);
    if (response?.Data?.JobId) {
      return { JobId: response.Data.JobId };
    }
    return null;
  } catch (error) {
    console.error('Error fetching TIN group details:', error);
    return null;
  } finally {
    _httpService.setBaseURL(previousBaseURL || '');
  }
};
